export default __webpack_public_path__ + "static/media/order-summary-success.98f69eff.svg";